import React from 'react';
import './skeleton.css'; // Import CSS for shimmer effect

const ProductItemSkeleton = () => {
  return (
    <div className="group bg-white border border-gray-100 transition-all duration-300 cursor-pointer relative rounded-md">
      {/* Image Container */}
      <div className="relative aspect-square overflow-hidden bg-[#ebe2db]">
        {/* Main Image Placeholder */}
        <div className="w-full h-full bg-gray-200 skeleton-inner"></div>

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-0"></div>

        {/* Top Row - Bestseller & Wishlist */}
        <div className="absolute top-2 left-2 right-2 flex justify-between items-start">
          {/* Bestseller Badge Placeholder */}
          <div className="bg-gray-200 h-5 w-20 rounded-sm skeleton-inner"></div>

          <div className="flex-1"></div>

          {/* Wishlist Button Placeholder */}
          <div className="bg-white bg-opacity-90 p-2 rounded">
            <div className="w-4 h-4 bg-gray-200 rounded skeleton-inner"></div>
          </div>
        </div>

        {/* Out of Stock Label Placeholder */}
        <div className="absolute bottom-1 right-1">
          <div className="bg-gray-200 h-6 w-16 skeleton-inner"></div>
        </div>
      </div>

      {/* Product Information */}
      <div className="p-4 space-y-2">
        {/* Category Placeholder */}
        <div className="h-3 bg-gray-200 rounded w-16 skeleton-inner"></div>

        {/* Product Name Placeholder */}
        <div className="space-y-1">
          <div className="h-4 bg-gray-200 rounded w-full skeleton-inner"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4 skeleton-inner"></div>
        </div>

        {/* Rating Placeholder */}
        <div className="flex items-center gap-1">
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="w-3 h-3 bg-gray-200 rounded skeleton-inner"></div>
            ))}
          </div>
          <div className="h-3 bg-gray-200 rounded w-8 ml-1 skeleton-inner"></div>
        </div>

        {/* Price Section */}
        <div className="flex items-center gap-2 pt-1">
          <div className="h-6 bg-gray-200 rounded w-16 skeleton-inner"></div>
          <div className="h-4 bg-gray-200 rounded w-12 skeleton-inner"></div>
          <div className="h-3 bg-gray-200 rounded w-12 ml-auto skeleton-inner"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductItemSkeleton;
